import LoadingSpinner from "../../components/LoadingSpinner";

const Loading = () => {
  return <LoadingSpinner />;
};

export default Loading;
